import { useMutation } from 'react-query';
import { postBumpItem } from '@sls-react/api/item';
import useV1Session from '@sls-react/hooks/useV1Session';
import { useModals } from '@sls-react/contexts/ModalsContext';
import { clickedBump } from '@sls-react/services/analytics/events/item';

export default function useBumpItem(itemId: number, onBumped?: () => void) {
  const modals = useModals();
  const session = useV1Session();
  const mutation = useMutation(() => postBumpItem(itemId), {
    onSuccess: onBumped,
  });

  function handleBump() {
    clickedBump({ availableBumpCount: session.data?.user?.available_bumps });

    if (session.data?.user?.items_bumped === 0) {
      modals.openModal('bumpsGuidance', {
        itemId,
        onSuccessfulBump: onBumped,
      });
      return;
    }

    if (session.data?.user?.available_bumps === 0) {
      modals.openModal('bumpsPurchase', {
        onSuccessfulPurchase: onBumped,
      });
      return;
    }

    return mutation.mutate();
  }

  return { ...mutation, mutate: handleBump, mutateAsync: handleBump };
}
